<template>

    <div class="tournament__participation__item">
        <div class="tournament__participation__item__title float-content">
            <p class="item-title fl" :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-06.svg')}')`}">
                {{isComplete ? playerName : `참가자${playerIndex}`}}</p>
            <p class="player__complete__label" v-if="isComplete">작성완료</p>
            <div class="player__delete" v-if="playerIndex > 0" @click="$emit('delete')">
                <span class="icon"></span>
                <span class="text">삭제</span>
            </div>

            <span class="player__display" @click="playerInfoShow = !playerInfoShow"
                  :class="playerInfoShow ? '' : 'hide'"></span>
        </div>

        <div class="form-control-select-wrap" v-show="playerInfoShow">
            <div class="form-control-select">
                <p class="input-title">이름</p>
                <input class="form-control-select" placeholder="입력해주세요" v-model="playerName" @input="changePlayerInfoFunc">
            </div>
            <div class="form-control-select">

                <p class="input-title">성별</p>
                <select class="form-control-select" v-model="gender" @change="changePlayerInfoFunc">
                    <option :value="null">성별</option>
                    <option value="M">남자</option>
                    <option value="W">여자</option>
                </select>
            </div>
            <div class="form-control-select">
                <p class="input-title">생년월일</p>
                <div class="form-control-select-birth">
<!--                    <input class="form-control-select" placeholder="입력" v-model="dateBirthYear" @input="changePlayerInfoFunc">-->
<!--                    <input class="form-control-select" placeholder="입력" v-model="dateBirthMonth" @input="changePlayerInfoFunc">-->
<!--                    <input class="form-control-select" placeholder="입력" v-model="dateBirthDate" @input="changePlayerInfoFunc">-->


                    <select class="form-control-select" v-model="dateBirthYear" @change="changePlayerInfoFunc">
                        <option :value="null">연도 선택</option>
                        <option  v-for="year in yearList"  :value="year">{{year}}년</option>
                    </select>
                    <select class="form-control-select" v-model="dateBirthMonth" @change="changePlayerInfoFunc">
                        <option :value="null">월 선택</option>
                        <option  v-for="month in 12"  :value="month < 10 ? `0${month}`:month">
                            {{ month < 10 ? `0${month}`:month }}월 </option>
                    </select>
                    <select class="form-control-select" v-model="dateBirthDate" @change="changePlayerInfoFunc">
                        <option :value="null">일 선택</option>
                        <option v-for="date in 31" :value="date < 10 ? `0${date}` : date">
                            {{date < 10 ? `0${date}` : date }}일
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-control-select">

                <p class="input-title">연락처</p>
                <div class="form-control-select-phone">
                    <input class="form-control-select" placeholder="입력" v-model="mobileFirst" @input="firstPhoneChangeFnc">
                    <input class="form-control-select" placeholder="입력" v-model="mobileSecond" @input="secondPhoneChangeFunc" ref="mobileSecond">
                    <input class="form-control-select" placeholder="입력" v-model="mobileLast" @input="lastPhoneChangeFunc" ref="mobileLast">
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import participantOpenFormMixin from "../../../mixins/participantOpenFormMixin";

    export default {
        mixins: [participantOpenFormMixin],
        data(){
            return{
                playerInfoShow: true,
                isComplete: false,
            }
        },
        props: ['team_name'],
        methods: {
            changePlayerInfoFunc(){
                const temp = {
                    "playerName": this.playerName,
                    "mobile": `${this.mobileFirst||''}${this.mobileSecond||''}${this.mobileLast||''}`,
                    "gender": this.gender,
                    "dateOfBirth": `${this.dateBirthYear||''}${this.dateBirthMonth||''}${this.dateBirthDate||''}`,
                    "teamName": null,
                    "type": 'P'
                }

                this.$emit('input', temp)
                let is_complete = true
                if(!this.playerName||!this.mobileFirst||!this.mobileSecond||!this.mobileLast||!this.dateBirthYear||!this.dateBirthMonth||!this.dateBirthDate||!this.teamName||!this.playerType){
                    this.isComplete = false
                }else{
                    this.isComplete = true
                }
            }
        }
    }
</script>
